import {
	Button,
	DialogActions,
	DialogContent,
	DialogTitle,
} from '@mui/material'

type DeleteFormPackageProcessorDialogProps = {
	processorName: string
	onConfirm: () => void
	onCancel: () => void
}

export const DeleteFormPackageProcessorDialog = (
	props: DeleteFormPackageProcessorDialogProps,
) => {
	return (
		<>
			<DialogTitle>Confirm Delete Form Package Processor</DialogTitle>
			<DialogContent>
				Are you sure you want to delete the {props.processorName} form package
				processor?
			</DialogContent>
			<DialogActions>
				<Button variant="outlined" onClick={props.onCancel}>
					Cancel
				</Button>
				<Button variant="contained" onClick={props.onConfirm}>
					Confirm
				</Button>
			</DialogActions>
		</>
	)
}
